import { Component, Input, Output, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { AssigTripsService } from 'src/app/component/assigned-trips/assigntrips-service/assigntrips-service';
import { sweetAlert } from 'src/app/utils/swal';
import { legTypeMap } from 'src/app/utils/utils.common';

@Component({
  selector: 'app-bulk-actions-modal',
  templateUrl: './bulk-actions-modal.component.html',
  styleUrls: ['./bulk-actions-modal.component.css']
})
export class BulkActionsModalComponent implements OnInit, OnDestroy {

  @Input() trips: any[] = [];
  @Input() lookupData: any;
  @Output() onClose = new EventEmitter<void>();
  @Output() onSuccess = new EventEmitter<void>();

  // Same keys and labels as app-trip-actions-dropdown stamps
  stamps = [
    { key: 'isReadyForPickup', title: 'Mark Ready' },
    { key: 'isVipTrip', title: 'Mark VIP' },
    { key: 'notAnswer', title: 'Mark No Ph. Answer' },
    { key: 'badPhoneNumber', title: 'Mark Bad Ph. Number' },
    { key: 'isConfirmedTrip', title: 'Mark Confirm' },
    { key: 'isVoiceMail', title: 'Mark Voicemail' },
    { key: 'isMultiLoad', title: 'Mark Multiload' },
    { key: 'isMethadone', title: 'Mark Methadone' },
    { key: 'isDeadMiles', title: 'Mark Dead Miles' },
    { key: 'isDialysis', title: 'Mark Dialysis' },
  ];
  selectedStamps = {};
  // Stamps that cannot be applied together
  exclusiveStamps = {
    isConfirmedTrip: 'isVoiceMail',
    isVoiceMail: 'isConfirmedTrip',
  };
  isSubmitting = false;
  preSpaceTypes: any;
  preCooperates: any;
  timeFormat = 'HHmm';
  legTypeMap = legTypeMap;

  constructor(
    private sharedDataService: SharedDataService,
    private assignTripService: AssigTripsService,
    private toastr: ToastrService,
  ) { }

  ngOnInit() {
    if (this.lookupData) {
      this.preSpaceTypes = this.lookupData.spaceTypes;
      this.preCooperates = this.lookupData.cooperates;
    }
    this.sharedDataService
      .getUser().pipe(takeUntil(componentDestroyed(this))).subscribe((data) => {
        if (data && data.timeFormat) {
          this.timeFormat = data.timeFormat;
        }
      });
  }

  onStampChange(key, checked) {
    this.selectedStamps[key] = checked;
    if (checked && this.exclusiveStamps[key]) {
      this.selectedStamps[this.exclusiveStamps[key]] = false;
    }
  }

  get hasSelectedStamp() {
    return this.stamps.some(stamp => this.selectedStamps[stamp.key]);
  }

  apply() {
    if (this.isSubmitting) return;
    if (!this.trips || !this.trips.length) {
      this.toastr.error('Please select at least one trip.', 'Alert');
      return;
    }
    if (!this.hasSelectedStamp) {
      this.toastr.error('Please select at least one action.', 'Alert');
      return;
    }

    const payload: any = {
      _ids: this.trips.map(trip => trip._id),
    };
    this.stamps.forEach(stamp => {
      if (this.selectedStamps[stamp.key]) {
        payload[stamp.key] = true;
      }
    });

    sweetAlert(
      'Alert',
      `Are you sure you want to apply the selected action(s) to ${payload._ids.length} selected trip(s)?`,
      'warning',
      'Yes',
      'No'
    ).then((result: any) => {
      if (!result.value || this.isSubmitting) return;
      this.isSubmitting = true;
      this.assignTripService
        .markFlagsBulk(payload)
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe(() => {
          this.isSubmitting = false;
          this.toastr.success('Trips updated successfully!', 'Alert');
          this.onSuccess.emit();
        }, (err) => {
          this.isSubmitting = false;
          this.toastr.error(err || 'Something went wrong!', 'Alert');
        });
    });
  }

  close() {
    this.onClose.emit();
  }

  ngOnDestroy(): void {
  }
}
